import $ from 'jquery';
import debounce from 'lodash/debounce';

import Dt from 'datatables.net';
import DtFoundation from 'datatables.net-zf';
import DtResponsive from 'datatables.net-responsive';
import DtSelect from 'datatables.net-select';

Dt(window, $);
DtFoundation(window, $);
DtResponsive(window, $);
DtSelect(window, $);

$.extend(true, $.fn.dataTable.defaults, {
  pageLength: 25,
  stripeClasses: [],
  dom: "<'row table-controls--top'" +
  "<'small-6 medium-6 columns'<'table-controls--top__left'l>>" +
  "<'small-6 medium-6 columns'<'table-controls--top__right'f>>" +
  'r>' +
  't' +
  "<'row table-controls--bottom'<'small-12 medium-6 columns'i><'small-12 medium-6 columns'p>>",
  renderer: 'foundation',
  language: {
    lengthMenu: '_MENU_ per page',
    search: '',
    searchPlaceholder: 'Search',
  },
  processing: true,
  responsive: true,
  stateSave: true,
  initComplete() {
    // Force the table to fit in the window so that the responsive extension can work its magic.
    const updateWrapperWidth = () => {
      const $wrapper = this.parent();
      $wrapper.css('max-width', '320px');
      $wrapper.css('max-width', `${$wrapper.parent().width()}px`);
      this.api().columns.adjust();
      this.api().responsive.recalc();
    };
    $(window).on('resize', debounce(updateWrapperWidth, 500));
    updateWrapperWidth();
  },
});
